import { ReduceStore } from 'flux/utils';
import { dispatcher } from './dispatcher';

export default class Store extends ReduceStore {

	constructor()
	{
		super(dispatcher);
	}
	
	reduce(state, action) {
		var handler = 'on' + action.getActionHandler();
		var callback = this[handler];

		if(callback) {
			var rs = Object.assign({}, state);
			callback.call(this, rs, action.getPayload());
			return rs;
		} else {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/utils/store.js